<template>
    <div class="medals-page">
        <div class="page-head">
            <div class="left">
                <h1>Manage medals</h1>
            </div>
        </div>
        <MedalsList ref="MedalsList"></MedalsList>
    </div>
</template>

<script>
    import MedalsList from '@/components/Medals/MedalsList'
    export default {
        name: "Medals",
        components: {
            MedalsList
        },

        methods: {

        },
        mounted() {}
    };
</script>
